import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';

import { callFunction } from '@/lib/callableClient';

import { ingestionSourcesQueryKey } from './useIngestionSources';

interface Payload {
  homeId: string;
  keyHash: string;
}

export default function useDeleteIngestionKey() {
  const qc = useQueryClient();
  return useMutation<{ ok: true }, Error, Payload>({
    mutationFn: (payload) => callFunction<Payload, { ok: true }>('deleteIngestionKeyCallable', payload),
    onSuccess: (_data, vars) => {
      void qc.invalidateQueries({ queryKey: ingestionSourcesQueryKey(vars.homeId) });
      toast.success('Ingestion key deleted.');
    },
    onError: (err) => {
      toast.error(err.message || 'Failed to delete ingestion key.');
    },
  });
}
